import axios from "axios";
const URL = process.env.VUE_APP_API;

export default {
  getResources() {
    return axios.get(`${URL}/resources`).then((res) => {
      return res.data;
    });
  },
  createResource(payload) {
    return axios.post(`${URL}/resources`, { resource: payload }).then((res) => {
      return res.data;
    });
  },
  updateResource(payload) {
    return axios
      .patch(`${URL}/resources/${payload.id}.json`, { resource: payload })
      .then((res) => {
        return res.data;
      });
  },
  getResource(id) {
    return axios.get(`${URL}/resources/${id}`).then((res) => {
      return res.data;
    });
  },
  getResourceTags() {
    return axios.get(`${URL}/resource_tags`).then((res) => {
      return res.data;
    });
  },
  deleteResource(id) {
    return axios.delete(`${URL}/resources/${id}`).then((res) => {
      return res.data;
    });
  },
};
